import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import {
  SR_HITLIST_TASK_CALL_OUTCOME_ANSWERED,
  SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED,
  SR_HITLIST_TASK_CALL_OUTCOME_NO_CALL_NEEDED,
} from 'common/hitlistTaskConstants';

import { SR_CHECKBOX_THEME_BOX } from 'client/components/Checkbox';
import SrBox from 'client/components/SrBox';
import SrFormikField from 'client/components/SrFormikField';

import './HitlistTaskListRow.less';

const HitlistTaskListRowCallOutcome = ({ hitlistTask, onUpdate }) => {
  const formFieldCallOutcome = {
    id: 'callOutcome',
    type: 'multiple_choice',
    properties: {
      choices: [
        {
          label: 'Answered',
          value: SR_HITLIST_TASK_CALL_OUTCOME_ANSWERED,
        },
        {
          label: 'No Answer',
          value: SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED,
        },
        {
          label: 'No Call Needed',
          value: SR_HITLIST_TASK_CALL_OUTCOME_NO_CALL_NEEDED,
        },
      ],
      multipleSelection: false,
      fieldType: SR_CHECKBOX_THEME_BOX,
      className: 'adobe yesnoFullWidth',
      checkboxListClassName: 'checkboxListBoolean',
      onChange: (callOutcome) => {
        onUpdate({
          hitlistTask,
          updates: {
            callOutcome,
          },
        });
      },
    },
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        callOutcome: hitlistTask.callOutcome,
      }}
      render={(formikBag) => {
        return (
          <div styleName="section">
            <span styleName="title">Call Outcome</span>
            <SrBox width="460px">
              <SrFormikField formField={formFieldCallOutcome} formikBag={formikBag} />
            </SrBox>
          </div>
        );
      }}
    />
  );
};

HitlistTaskListRowCallOutcome.propTypes = {
  hitlistTask: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

HitlistTaskListRowCallOutcome.displayName = 'HitlistTaskListRowCallOutcome';

export default HitlistTaskListRowCallOutcome;
